<script setup lang="ts">

import Skeleton from '@/application/components/ui/Skeleton.vue';
</script>

<template>
  <div class="flex flex-col justify-end gap-5 mt-5">
    <Skeleton gradient class="w-full h-24" />
    <Skeleton gradient class="w-full h-24" />
    <Skeleton gradient class="w-full h-24" />
  </div>
</template>
